import { pods_carousels, initPodsCarousel } from './carousel';

export default function () {
  document.addEventListener('shopify:section:load', (e) => {
    const id = `PodsCarousel${e.detail.sectionId}`;
    const carouselElement = document.getElementById(id);
    // Is this a carousel?
    if (carouselElement) {
      let index = 0;

      // Has this carousel already been initialized? Destroy it if so...
      if (pods_carousels[id]) {
        // Save the current slide's index so we can immediately reinitialize at the same slide later
        index = pods_carousels[id].selectedIndex;
        // Destroy the existing one since it exists
        pods_carousels[id].destroy();
        delete pods_carousels[id];
      }

      // Reinitialize the carousel with new options
      initPodsCarousel(carouselElement, index);
    }
  });

  document.addEventListener('shopify:block:select', (e) => {
    const id = `PodsCarousel${e.detail.sectionId}`;
    const carouselElement = document.getElementById(id);
    // Is this a carousel?
    if (carouselElement) {
      // Navigate to the correct slide and pause autoplay
      const blockId = e.detail.blockId;
      const blockElement = document.getElementById(`Pod${blockId}`);
      const multiplier = pods_carousels[id].slides.length / pods_carousels[id].cells.length;
      const index = Math.floor(Array.from(blockElement.parentNode.children).indexOf(blockElement) * multiplier);

      pods_carousels[id].select(index);
      pods_carousels[id].pausePlayer();
    }
  });

  document.addEventListener('shopify:block:deselect', (e) => {
    const id = `PodsCarousel${e.detail.sectionId}`;
    const carouselElement = document.getElementById(id);
    // Is this a carousel?
    if (carouselElement) {
      // Unpause autoplay
      pods_carousels[id].unpausePlayer();
    }
  });
}
